import React from "react"
import axios from "axios"
import AppStore from "../AppStore"
import {observer} from "mobx-react"
import { Redirect } from "react-router-dom";

@observer
class CheckPaiement extends React.Component {
  calculateState(){
    axios.post("/api/v1/experts/app/montants",{id: AppStore.rdv.id}).then((data)=>{
      if(data.data.needredirect==true || data.data.surcout_valide==true){
        this.setState({
          redirect: true
        })
      }else{
        this.setState({
          montantPaye: data.data.montantPaye,
          nouveauMontant: data.data.nouveaumontant,
          repartition: data.data.repartition,
          apayer: data.data.apayer,
          loaded: true
        })
      }
    })

  }
  componentDidMount(){
    M.updateTextFields();
  }
  constructor(props) {
    super(props);
    this.calculateState = this.calculateState.bind(this);
    this.setAsMeuble = this.setAsMeuble.bind(this);
    this.handleValidateContreExpert = this.handleValidateContreExpert.bind(this);
    this.state = {
      montantPaye: 0,
      nouveauMontant: 0,
      apayer: 0,
      repartition: "",
      contreexpert: false,
      cexpert_prenom: "",
      cexpert_nom: "",
      cexpert_adress: "",
      loaded: false
    };
    this.calculateState()
  }
  validateSurCouts(e){
    e.preventDefault()
    axios.post("/api/v1/experts/app/validateSurCouts",{id: AppStore.rdv.id}).then((data)=>{
      location.reload();
    })
  }

  setAsMeuble(){
    axios.post("/api/v1/experts/app/bien/updateAmeublement",{id: AppStore.rdv.id}).then((data)=>{
      this.calculateState();
      AppStore.rdv.meuble = data.data.status
    })
  }
  handleValidateContreExpert(e){
    e.preventDefault();
    AppStore.validateContreExpert()

  }
  render () {
    if(this.state.redirect==true){
      return(<Redirect to="/PayLink" />)
    }
    if(!this.state.loaded){
      return(
      <React.Fragment>
      <h1 className="center">Chargement en cours des données du serveurs</h1>
      </React.Fragment>

        )
    }else{
      return (
        <React.Fragment>
        <h1 className="center">Validation des possible "surs-couts"</h1>
        <div className="container">
          <p>Le montant payé au total {this.state.repartition} : {this.state.montantPaye}€, <br/>nouveau montant : {this.state.nouveauMontant}</p>
          <p className="red-text">Il y'a donc encore {this.state.apayer}€ à payer</p>
          <p>Avant de procéder au paiement restant merci de cocher les surs-couts possibles</p>
          <div className="row">
            <div className="input-field col s3">
              <div className="row">
                 <h3> Le bien est il meublé ?</h3>
                  <div className="switch">
                    <label>
                      Non
                      <input type="checkbox"  defaultChecked={AppStore.bien.meuble} onChange={this.setAsMeuble}/>
                      <span className="lever"></span>
                      Oui
                    </label>
                  </div>
              </div>
            </div>
            <div className="input-field col s3">
              <div className="row">
                 <h3> Contre expert ?</h3>
                  <div className="switch">
                    <label>
                      Non
                      <input type="checkbox"  defaultChecked={AppStore.ordremission.contreexpert} onChange={(e) => AppStore.contreExpertPresence(this)}/>
                      <span className="lever"></span>
                      Oui
                    </label>
                  </div>
              </div>
            </div>
            <div className="col s6">
              {AppStore.ordremission.contreexpert ? (
                <div>
                {AppStore.cexpert_saved ? (
                      <p className="green-text">Contre expert enregistré</p>
                  ) : (
                    <div></div>
                  )}
                  <div className="row">
                    <div className="input-field col s6">
                      <input type="text" id="Penom" value={AppStore.ordremission.cexpert_prenom} onChange={(e)=>AppStore.ordremission.cexpert_prenom=e.target.value}/>
                      <label htmlFor="Prenom">Prénom</label>
                    </div>
                    <div className="input-field col s6">
                      <input type="text" id="Nom" value={AppStore.ordremission.cexpert_nom} onChange={(e)=>AppStore.ordremission.cexpert_nom=e.target.value}/>
                      <label htmlFor="Nom">Nom</label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="input-field col s12">
                      <input type="text" id="Adr" value={AppStore.ordremission.cexpert_adress} onChange={(e)=>AppStore.ordremission.cexpert_adress=e.target.value}/>
                      <label htmlFor="Adr">Adresse</label>
                    </div>
                  </div>
                  <div className="row">
                    {AppStore.cexpert_valid  ? (
                    <a href="" onClick={this.handleValidateContreExpert} className="btn btn-large"><i className="material-icons left">save</i>contre-expert</a>
                    ) : (
                    <a href="" className="btn btn-large disabled"><i className="material-icons left">save</i>Update</a>

                    )}
                  </div>
                </div>
                ) : (
                  <div>

                  </div>
                )}
            </div>
          </div>
        </div>
        <div className="row">
        <div className="col s3 offset-s9">
          <a href="" onClick={this.validateSurCouts} className="btn btn-large green"><i className="material-icons left">done</i>Valider</a>
        </div>
        </div>

        </React.Fragment>
      );
    }
  }
}

export default CheckPaiement
